<template>
  <div class="robot-analysis">
    <div class="analysis-nav-bar">
      <van-nav-bar title="效果分析" left-arrow @click-left="onClickLeft" />
    </div>
    <div class="header-bg" />
    <van-tabs class="robot-tabs" v-model="tabActive" color="#FFFFFF" line-width="30px">
      <van-tab title="会员分析">
        <member-analysis ref="memberChart" />
      </van-tab>
      <van-tab title="复购分析">
        <repurchase-analysis ref="repurchaseChart" />
      </van-tab>
      <van-tab title="营销分析">
        <market-analysis ref="marketChart" />
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import DrawCanvas from './components/DrawCanvas'
import MemberAnalysis from './components/MemberAnalysis'
import MarketAnalysis from './components/MarketAnalysis'
import RepurchaseAnalysis from './components/RepurchaseAnalysis'
import { appFinish, setStateBarColor } from '@/utils/appMe.js'

export default {
  components: {
    MemberAnalysis,
    MarketAnalysis,
    RepurchaseAnalysis
  },
  data() {
    return {
      resultData: {},
      tabActive: 0
    }
  },
  computed: {},
  watch: {
    tabActive(value) {
      this.$nextTick(() => {
        this.resizeChart(value)
      })
    }
  },
  beforeCreate() {
    setStateBarColor('#4978F2', 1, 1)
  },
  destroyed() {
    setStateBarColor()
  },
  created() {},
  methods: {
    onClickLeft() {
      appFinish()
    },
    resizeChart(value) {
      if (value === 0) {
        if (this.$refs.memberChart) {
          this.$refs.memberChart.resizeChart()
        }
      } else if (value === 1) {
        if (this.$refs.repurchaseChart) {
          this.$refs.repurchaseChart.resizeChart()
        }
      } else if (value === 2) {
        if (this.$refs.marketChart) {
          this.$refs.marketChart.resizeChart()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.robot-analysis {
  background: #f0f4f8;
  width: 375px;
  min-height: 100vh;
  .analysis-nav-bar {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 999;
    .van-nav-bar {
      background: #4a79f3;
    }
    .van-nav-bar__left {
      .van-icon {
        color: #ffffff;
        font-size: 18px;
      }
    }
    .van-nav-bar__title {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #ffffff;
    }
    .van-hairline--bottom::after {
      border: none;
    }
  }
  .header-bg {
    height: 149px;
    width: 100%;
    background: #4a79f3;
  }

  .robot-tabs {
    margin-top: -115px;
    width: 347px;
    padding: 0 14px 15px;

    /deep/ .van-tabs__nav {
      background: #4a79f3;
    }
    /deep/ .van-tab {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
    }
    /deep/ .van-tab--active {
      color: rgba(255, 255, 255, 1);
    }
    /deep/ .van-hairline--top-bottom:after,
    /deep/ .van-hairline-unset--top-bottom:after {
      border: none;
    }
    /deep/ .van-tabs__wrap {
      height: 50px;
    }
    /deep/ .van-tabs__nav--line {
      height: auto;
      padding-bottom: 12px;
    }
  }
  /deep/ .empty-ctn {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 48px;
    .empty-img {
      width: 274px;
      height: 190px;
      img {
        display: block;
        width: 100%;
      }
    }
    .no-text {
      font-size: 14px;
      color: #a1a5b0;
    }
  }
  /deep/ .tip-container {
    p {
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 100%;
      font-weight: normal;
      vertical-align: baseline;
    }
    padding: 30px 10px 0 20px;
    .tip {
      font-size: 13px;
      margin-bottom: 10px;
    }
    span {
      font-size: 14px;
      font-weight: bold;
    }
  }
  /deep/ .van-loading {
    text-align: center;
    padding-top: 10%;
  }
}
</style>
